import React, { useState } from "react";
import { Table } from "react-bootstrap";
import { BiSolidEdit } from "react-icons/bi";
import { MdDelete } from "react-icons/md";
import axiosInstance from "../../../utils/axiosInstance";
import { delete_users } from "../../shared/ApiEndpoint";
import Alerts from "../../shared/Alerts";
import { user_details } from "../../shared/AlertMessages";
const TableItems = ({ data ,setUser,handleShow}) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [id, SetselectedId] = useState(null);

  const handleDelete = (id) => {
    setShowConfirmModal(true);
    SetselectedId(id);
  };
  const delete_user = async (user_id) => {
    try {
      const response = await axiosInstance.put(
        `${delete_users}/${user_id}`,
        {},
        { withCredentials: true }
      );
      if (response?.status === 200) {
        const res = data.filter((item) => item.id !== user_id);
        setUser(res);
      }
    } catch (err) {
      console.log(err);
    }
  };

  

  return (
    <div>
      <Table responsive="sm" bordered>
        <thead>
          <tr>
            <th>#</th>
            <th>User Name</th>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Email</th>
            <th>Role</th>
            <th>Actions</th>
            {/* <th>Table heading</th>
            <th>Table heading</th> */}
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{item?.userName}</td>
              <td>{item?.FirstName}</td>
              <td>{item?.LastName}</td>
              <td>{item?.email}</td>
              <td>{item?.rolename}</td>
              <td>
                <div className="d-flex justify-content-center">
                  <div className="globalCursor" onClick={()=>handleShow(item)}>
                    <BiSolidEdit size={19} />
                  </div>
                  <div
                    className="text-danger globalCursor"
                    onClick={() => handleDelete(item?.id)}
                  >
                    <MdDelete size={19} />
                  </div>
                </div>
              </td>
            </tr>
            
          ))}
        </tbody>
      </Table>
      {showConfirmModal && (
        <Alerts
          antTitle={user_details.text}
          antContent={user_details.content}
          antOkText={user_details.confirm}
          antCancelText={user_details.cancel}
          confirmMsgText={user_details.confirmtext}
          id={id}
          setShowConfirmModal={setShowConfirmModal}
          action={delete_user}
        />
      )}
    </div>
  );
};

export default TableItems;
